import Vimeo from './Vimeo'
import Image from './Image'
import Youtube from './Youtube'

export default {
  Vimeo,
  Youtube,
  Image,
}
